module.exports = __webpack_public_path__ + "img/icon02.145e5053.png";